// Mobile/Backend의 UserLevelDef와 동기 (10단계 식물·자연 테마).
// backend: domain/user/level/UserLevelDef.kt 와 1:1 매칭.

export interface UserLevel {
    level: number;
    thresholdXp: number;
    nextThresholdXp: number | null;
    nameKo: string;
    cefrLabel: string;
}

const ENTRIES: Array<Omit<UserLevel, 'nextThresholdXp'>> = [
    { level: 1, thresholdXp: 0, nameKo: '새싹', cefrLabel: 'Pre-A1~A1' },
    { level: 2, thresholdXp: 300, nameKo: '잎사귀', cefrLabel: 'A1' },
    { level: 3, thresholdXp: 3_000, nameKo: '꽃봉오리', cefrLabel: 'A2' },
    { level: 4, thresholdXp: 6_000, nameKo: '꽃', cefrLabel: 'A2~B1' },
    { level: 5, thresholdXp: 10_500, nameKo: '꿀', cefrLabel: 'B1' },
    { level: 6, thresholdXp: 15_000, nameKo: '뿌리', cefrLabel: 'B2 초입' },
    { level: 7, thresholdXp: 24_000, nameKo: '정령', cefrLabel: 'B2' },
    { level: 8, thresholdXp: 33_000, nameKo: '탐험가', cefrLabel: 'C1 초입' },
    { level: 9, thresholdXp: 45_000, nameKo: '글로벌', cefrLabel: 'C1~C2' },
    { level: 10, thresholdXp: 60_000, nameKo: '마스터', cefrLabel: 'C2~네이티브' },
];

export function levelFromXp(xp: number): UserLevel {
    const safeXp = Math.max(0, xp);
    let idx = 0;
    for (let i = ENTRIES.length - 1; i >= 0; i -= 1) {
        if (safeXp >= ENTRIES[i].thresholdXp) {
            idx = i;
            break;
        }
    }
    const cur = ENTRIES[idx];
    const next = ENTRIES[idx + 1] ?? null;
    return {
        ...cur,
        nextThresholdXp: next?.thresholdXp ?? null,
    };
}

export function levelProgress(xp: number, lv: UserLevel): number {
    if (lv.nextThresholdXp == null) return 1;
    const span = Math.max(1, lv.nextThresholdXp - lv.thresholdXp);
    return Math.min(1, Math.max(0, (xp - lv.thresholdXp) / span));
}
